'use strict';

exports.__esModule = true;
exports.TemplateView = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _App = require('../../../../App');

var _App2 = _interopRequireDefault(_App);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TemplateView = exports.TemplateView = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(TemplateView, _PrismaCmsComponent);

  function TemplateView(props) {
    _classCallCheck(this, TemplateView);

    var _this = _possibleConstructorReturn(this, _PrismaCmsComponent.call(this, props));

    var _props$inEditMode = props.inEditMode,
        inEditMode = _props$inEditMode === undefined ? false : _props$inEditMode;
    _this.state = _extends({}, _this.state, {
      inEditMode: inEditMode
    });
    return _this;
  }

  TemplateView.prototype.render = function render() {
    var _this2 = this;

    var _context = this.context,
        Grid = _context.Grid,
        TemplateLink = _context.TemplateLink,
        UserLink = _context.UserLink;

    var _props = this.props,
        classes = _props.classes,
        object = _props.data.object,
        editable = _props.editable,
        edit_button_styles = _props.edit_button_styles,
        other = _objectWithoutProperties(_props, ['classes', 'data', 'editable', 'edit_button_styles']);

    var inEditMode = this.state.inEditMode;

    if (!object) {
      return null;
    }

    var name = object.name,
        component = object.component,
        description = object.description,
        CreatedBy = object.CreatedBy;
    var toolbar = void 0;

    if (editable || true) {
      toolbar = _react2.default.createElement(Grid, {
        rel: 'noindex, nofollow',
        container: true,
        style: _extends({
          // flexDirection: "row-reverse",
          position: "fixed",
          bottom: 0,
          right: 0,
          width: "auto",
          background: "rgba(255,255,255,0.5)",
          zIndex: 2000
        }, edit_button_styles)
      }, _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement(_Button2.default, {
        size: 'small',
        onClick: function onClick(event) {
          return _this2.setState({
            inEditMode: !inEditMode
          });
        },
        variant: 'raised'
      }, inEditMode ? this.lexicon("Close") : this.lexicon("Edit template"))));
    }

    return _react2.default.createElement(_Paper2.default, {
      style: {
        padding: 10,
        position: "relative"
      }
    }, toolbar, _react2.default.createElement(Grid, {
      container: true,
      spacing: 8,
      alignItems: 'center'
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: true
    }, _react2.default.createElement(TemplateLink, {
      object: object
    }, name, ' / ', component)), _react2.default.createElement(Grid, {
      item: true
    }, CreatedBy ? _react2.default.createElement(UserLink, {
      user: CreatedBy
    }) : null), _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, description ? _react2.default.createElement(_Typography2.default, {
      variant: 'caption'
    }, description) : null)), _react2.default.createElement(_App2.default, _extends({
      data: {
        object: object
      }
    }, other, {
      inEditMode: inEditMode
    })));
  };

  return TemplateView;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  editable: _propTypes2.default.bool.isRequired,
  edit_button_styles: _propTypes2.default.object
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  editable: false
}), _temp);
exports.default = TemplateView; // export default withStyles(styles)(props => <TemplateView
//   {...props}
// />);